import { useAppSelector } from "../store";

export const useDirectorId = () => {
  const selectedEntity = useAppSelector((st) => st.me.selectedEntity);

  return selectedEntity?._id;
};
